// User roles - Admin, Department, Planning Official, and DoNER Official
export const USER_ROLES = {
  ADMIN: 'admin',
  DEPARTMENT: 'department',
  PLANNING_OFFICIAL: 'planning_official',
  DONER: 'doner_official'
};

// Roles that are not tied to a single sector/department.
// These accounts do not require (or use) the sector and department fields.
export const NON_DEPARTMENT_ROLES = [
  USER_ROLES.ADMIN,
  USER_ROLES.PLANNING_OFFICIAL,
  USER_ROLES.DONER
];

export const isNonDepartmentRole = (role) => NON_DEPARTMENT_ROLES.includes(role);

// User status constants
export const USER_STATUS = {
  PENDING: 'pending',
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  SUSPENDED: 'suspended'
};

// Sectors for StateSync
export const SECTORS = [
  { value: 'agri-allied', label: 'Agri & Allied' },
  { value: 'rural-development', label: 'Rural Development' },
  { value: 'special-area-programme', label: 'Special Area Programme' },
  { value: 'irrigation', label: 'Irrigation' },
  { value: 'energy', label: 'Energy' },
  { value: 'industries-minerals', label: 'Industries & Minerals' },
  { value: 'transport', label: 'Transport' },
  { value: 'sc-tech', label: 'Sc & Tech' },
  { value: 'general-eco-services', label: 'General Eco. Services' },
  { value: 'social-services', label: 'Social Services' },
  { value: 'general-services', label: 'General Services' },
  { value: 'others', label: 'Others' }
];

// DEPARTMENTS - Keep for backward compatibility, but migrate to departmentService
export const DEPARTMENTS = [
  // Agri & Allied
  { value: 'dept-agriculture', label: 'Agriculture', sector: 'agri-allied' },
  { value: 'dept-horticulture', label: 'Horticulture', sector: 'agri-allied' },
  { value: 'dept-soil-water-conservation', label: 'Soil & Water Conservation', sector: 'agri-allied' },
  { value: 'dept-ah-vety-service', label: 'A.H & Vety Service', sector: 'agri-allied' },
  { value: 'dept-fisheries', label: 'Fisheries', sector: 'agri-allied' },
  { value: 'dept-forestry-wildlife', label: 'Forestry & Wildlife', sector: 'agri-allied' },
  { value: 'dept-cooperation', label: 'Cooperation', sector: 'agri-allied' },
  { value: 'dept-land-resources-development', label: 'Land Resources Development', sector: 'agri-allied' },
  { value: 'dept-nagaland-bamboo-dev-agency', label: 'Nagaland Bamboo Dev. Agency', sector: 'agri-allied' },
  { value: 'dept-bio-resource-aromatic-plant', label: 'Bio-resource & Aromatic Plant', sector: 'agri-allied' },
  { value: 'dept-bee-honey-mission', label: 'Bee & Honey Mission', sector: 'agri-allied' },
  { value: 'dept-neped', label: 'NEPED', sector: 'agri-allied' },
  { value: 'dept-hydroger', label: 'Hydroger', sector: 'agri-allied' },
  
  // Rural Development
  { value: 'dept-rural-development', label: 'Rural Development', sector: 'rural-development' },
  { value: 'dept-sird', label: 'SIRD', sector: 'rural-development' },
  { value: 'dept-land-revenue', label: 'Land Revenue', sector: 'rural-development' },
  
  // Special Area Programme
  { value: 'dept-special-development-scheme', label: 'Special Development Scheme', sector: 'special-area-programme' },
  { value: 'dept-local-area-development-programme', label: 'Local Area Development Programme', sector: 'special-area-programme' },
  { value: 'dept-development-under-developed-areas', label: 'Development of Under Developed Areas', sector: 'special-area-programme' },
  
  // Irrigation
  { value: 'dept-water-resources', label: 'Water Resources', sector: 'irrigation' },
  
  // Energy
  { value: 'dept-distribution-revenue-dr', label: 'Distribution & Revenue (D&R)', sector: 'energy' },
  { value: 'dept-transmission-generation-tg', label: 'Transmission & Generation (T&G)', sector: 'energy' },
  { value: 'dept-new-renewable-energy', label: 'New& Renewable Energy', sector: 'energy' },
  { value: 'dept-electrical-inspectorate', label: 'Electrical Inspectorate', sector: 'energy' },
  
  // Industries & Minerals
  { value: 'dept-industries-commerce', label: 'Industries & Commerce', sector: 'industries-minerals' },
  { value: 'dept-sericulture', label: 'Sericulture', sector: 'industries-minerals' },
  { value: 'dept-geology-mining', label: 'Geology & Mining', sector: 'industries-minerals' },
  { value: 'dept-nsmdc', label: 'NSMDC', sector: 'industries-minerals' },
  
  // Transport
  { value: 'dept-roads-bridges', label: 'Roads & Bridges', sector: 'transport' },
  { value: 'dept-mechanical-engineering', label: 'Mechanical Engineering', sector: 'transport' },
  { value: 'dept-road-transport', label: 'Road Transport', sector: 'transport' },
  { value: 'dept-motor-vehicle', label: 'Motor Vehicle', sector: 'transport' },
  
  // Sc & Tech
  { value: 'dept-science-technology', label: 'Science and Technology', sector: 'sc-tech' },
  { value: 'dept-information-technology-com', label: 'Information Technology & Com', sector: 'sc-tech' },
  
  // General Eco. Services
  { value: 'dept-planning-machinery', label: 'Planning Machinery', sector: 'general-eco-services' },
  { value: 'dept-tourism', label: 'Tourism', sector: 'general-eco-services' },
  { value: 'dept-economics-statistics', label: 'Economics & Statistics', sector: 'general-eco-services' },
  { value: 'dept-civil-supplies', label: 'Civil Supplies', sector: 'general-eco-services' },
  { value: 'dept-legal-metrology-cp', label: 'Legal Metrology & CP', sector: 'general-eco-services' },
  { value: 'dept-evaluation', label: 'Evaluation', sector: 'general-eco-services' },
  
  // Social Services
  { value: 'dept-school-education', label: 'School Education', sector: 'social-services' },
  { value: 'dept-higher-education', label: 'Higher Education', sector: 'social-services' },
  { value: 'dept-scert', label: 'SCERT', sector: 'social-services' },
  { value: 'dept-technical-education', label: 'Technical Education', sector: 'social-services' },
  { value: 'dept-sports-youth-services', label: 'Sports & Youth Services', sector: 'social-services' },
  { value: 'dept-art-culture', label: 'Art & Culture', sector: 'social-services' },
  { value: 'dept-health-family-welfare', label: 'Health & Family Welfare', sector: 'social-services' },
  { value: 'dept-public-health-engineering', label: 'Public Health Engineering', sector: 'social-services' },
  { value: 'dept-pwd-housing', label: 'PWD Housing', sector: 'social-services' },
  { value: 'dept-ga-housing', label: 'G.A. Housing', sector: 'social-services' },
  { value: 'dept-police-housing', label: 'Police Housing', sector: 'social-services' },
  { value: 'dept-law-justice', label: 'Law & Justice', sector: 'social-services' },
  { value: 'dept-home-guards-housing', label: 'Home Guards Housing', sector: 'social-services' },
  { value: 'dept-jails-prison-housing', label: 'Jails (Prison) Housing', sector: 'social-services' },
  { value: 'dept-excise-housing', label: 'Excise Housing', sector: 'social-services' },
  { value: 'dept-urban-development', label: 'Urban Development', sector: 'social-services' },
  { value: 'dept-municipal-affairs', label: 'Municipal Affairs', sector: 'social-services' },
  { value: 'dept-information-public-relations', label: 'Information & Public Relations', sector: 'social-services' },
  { value: 'dept-labour', label: 'Labour', sector: 'social-services' },
  { value: 'dept-employment-skill-dev-entrepreneurship', label: 'Employment, Skill Dev & Entrepreneurship', sector: 'social-services' },
  { value: 'dept-social-welfare', label: 'Social Welfare', sector: 'social-services' },
  { value: 'dept-women-resources', label: 'Women Resources', sector: 'social-services' },
  
  // General Services
  { value: 'dept-printing-stationery', label: 'Printing & Stationery', sector: 'general-services' },
  { value: 'dept-administrative-training-institute', label: 'Administrative Training Institute', sector: 'general-services' },
  { value: 'dept-assembly-complex-project', label: 'Assembly Complex Project', sector: 'general-services' },
  { value: 'dept-fire-services', label: 'Fire Services', sector: 'general-services' },
  { value: 'dept-treasury-accounts', label: 'Treasury & Accounts', sector: 'general-services' },
  { value: 'dept-border-affairs', label: 'Border Affairs', sector: 'general-services' },
  { value: 'dept-parliamentary-affairs', label: 'Parliamentary Affairs', sector: 'general-services' },
  { value: 'dept-taxes', label: 'Taxes', sector: 'general-services' },
  { value: 'dept-village-guards', label: 'Village Guards', sector: 'general-services' },
  { value: 'dept-chief-electoral-officer', label: 'Chief Electoral Officer', sector: 'general-services' },
  { value: 'dept-home-incl-disaster-management', label: 'Home incl. Disaster management', sector: 'general-services' },
  { value: 'dept-tribal-affairs', label: 'Tribal Affairs', sector: 'general-services' },
  { value: 'dept-minority-affairs', label: 'Minority Affairs', sector: 'general-services' },
  { value: 'dept-state-lotteries', label: 'State Lotteries', sector: 'general-services' },

  // Other Sector Departments
  { value: 'dept-budget-initiative', label: 'Budget Initiative', sector: 'others' },
  { value: 'dept-others', label: 'Others', sector: 'others' }
];

// User status options for admin management
export const USER_STATUS_OPTIONS = [
  { 
    value: USER_STATUS.PENDING, 
    label: 'Pending Approval', 
    color: 'bg-yellow-100 text-yellow-800'
  },
  { 
    value: USER_STATUS.ACTIVE, 
    label: 'Active', 
    color: 'bg-green-100 text-green-800'
  },
  { 
    value: USER_STATUS.INACTIVE, 
    label: 'Inactive', 
    color: 'bg-gray-100 text-gray-800'
  },
  { 
    value: USER_STATUS.SUSPENDED, 
    label: 'Suspended', 
    color: 'bg-orange-100 text-orange-800'
  }
];

// Role labels for display
export const ROLE_LABELS = {
  [USER_ROLES.ADMIN]: 'Administrator',
  [USER_ROLES.DEPARTMENT]: 'Department User',
  [USER_ROLES.PLANNING_OFFICIAL]: 'Planning Official',
  [USER_ROLES.DONER]: 'DoNER Official'
};

// Role colors for badges
export const ROLE_COLORS = {
  [USER_ROLES.ADMIN]: 'bg-purple-100 text-purple-800',
  [USER_ROLES.DEPARTMENT]: 'bg-blue-100 text-blue-800',
  [USER_ROLES.PLANNING_OFFICIAL]: 'bg-indigo-100 text-indigo-800',
  [USER_ROLES.DONER]: 'bg-teal-100 text-teal-800'
};

// Authentication error messages
export const AUTH_ERROR_MESSAGES = {
  ACCOUNT_PENDING: 'Your account is pending approval. Please wait for admin approval.',
  ACCOUNT_INACTIVE: 'Your account has been deactivated. Please contact administrator.',
  ACCOUNT_SUSPENDED: 'Your account has been suspended. Please contact administrator.',
  EMAIL_ALREADY_EXISTS: 'An account with this email already exists.',
  INVALID_CREDENTIALS: 'Invalid email or password.',
  WEAK_PASSWORD: 'Password must be at least 6 characters long.',
  INVALID_EMAIL: 'Please enter a valid email address.',
  REQUIRED_FIELD: 'This field is required.',
  PASSWORD_MISMATCH: 'Passwords do not match.',
  UNAUTHORIZED: 'You are not authorized to perform this action.',
  SESSION_EXPIRED: 'Your session has expired. Please login again.'
};

// Success messages
export const AUTH_SUCCESS_MESSAGES = {
  REGISTRATION_SUCCESS: 'Registration successful! Your account is pending approval.',
  LOGIN_SUCCESS: 'Login successful!',
  LOGOUT_SUCCESS: 'Logged out successfully.',
  PASSWORD_RESET_SENT: 'Password reset email sent successfully.',
  USER_APPROVED: 'User approved successfully.',
  USER_DEACTIVATED: 'User deactivated successfully.',
  USER_ACTIVATED: 'User activated successfully.'
};

// Default user data structure
export const DEFAULT_USER_DATA = {
  fullName: '',
  email: '',
  password: '',
  confirmPassword: '',
  sector: '',
  department: '',
  role: USER_ROLES.DEPARTMENT,
  status: USER_STATUS.PENDING,
  createdAt: null,
  updatedAt: null,
  lastLoginAt: null,
  approvedAt: null,
  approvedBy: null
};

// Filter options for user management
export const USER_FILTER_OPTIONS = {
  status: [
    { value: '', label: 'All Status' },
    ...USER_STATUS_OPTIONS.map(status => ({
      value: status.value,
      label: status.label
    }))
  ],
  sector: [
    { value: '', label: 'All Sectors' },
    ...SECTORS.map(sector => ({
      value: sector.value,
      label: sector.label
    }))
  ],
  role: [
    { value: '', label: 'All Roles' },
    { value: USER_ROLES.ADMIN, label: ROLE_LABELS[USER_ROLES.ADMIN] },
    { value: USER_ROLES.DEPARTMENT, label: ROLE_LABELS[USER_ROLES.DEPARTMENT] },
    { value: USER_ROLES.PLANNING_OFFICIAL, label: ROLE_LABELS[USER_ROLES.PLANNING_OFFICIAL] },
    { value: USER_ROLES.DONER, label: ROLE_LABELS[USER_ROLES.DONER] }
  ],
  sort: [
    { value: 'name-asc', label: 'Name A-Z' },
    { value: 'name-desc', label: 'Name Z-A' },
    { value: 'email-asc', label: 'Email A-Z' },
    { value: 'createdAt-desc', label: 'Recently Registered' },
    { value: 'createdAt-asc', label: 'Oldest Registered' }
  ]
};

// User actions for management
export const USER_ACTIONS = {
  APPROVE: 'approve',
  EDIT: 'edit',
  DEACTIVATE: 'deactivate',
  ACTIVATE: 'activate',
  SUSPEND: 'suspend',
  DELETE: 'delete',
  VIEW_DETAILS: 'view_details'
};

// Permission levels
export const PERMISSIONS = {
  USER_MANAGEMENT: 'user_management',
  USER_MANAGEMENT_ACTIONS: 'user_management_actions', // New: For Actions column
  USER_CREATION: 'user_creation', // New: For Add User button
  VIEW_ANALYTICS: 'view_analytics'
};

// Role-based permissions
export const ROLE_PERMISSIONS = {
  [USER_ROLES.ADMIN]: [
    PERMISSIONS.USER_MANAGEMENT,
    PERMISSIONS.USER_MANAGEMENT_ACTIONS,
    PERMISSIONS.USER_CREATION,
    PERMISSIONS.VIEW_ANALYTICS
  ],
  [USER_ROLES.PLANNING_OFFICIAL]: [
    PERMISSIONS.USER_MANAGEMENT, // Can view user management
    PERMISSIONS.VIEW_ANALYTICS
    // Note: No USER_MANAGEMENT_ACTIONS or USER_CREATION
  ],
  [USER_ROLES.DONER]: [
    PERMISSIONS.USER_MANAGEMENT, // Can view user management
    PERMISSIONS.VIEW_ANALYTICS
    // Note: No USER_MANAGEMENT_ACTIONS or USER_CREATION
  ],
  [USER_ROLES.DEPARTMENT]: []
};

// Local storage keys
export const AUTH_STORAGE_KEYS = {
  USER: 'statesync_user',
  TOKEN: 'statesync_token'
};

// Route paths
export const AUTH_ROUTES = {
  LOGIN: '/login',
  SIGNUP: '/signup',
  FORGOT_PASSWORD: '/forgot-password',
  DASHBOARD: '/dashboard',
  USER_MANAGEMENT: '/admin/users'
};

// Validation limits
export const AUTH_VALIDATION_LIMITS = {
  NAME_MIN_LENGTH: 2,
  NAME_MAX_LENGTH: 100,
  PASSWORD_MIN_LENGTH: 6,
  PASSWORD_MAX_LENGTH: 128
};

// Helper function to get departments by sector
export const getDepartmentsBySector = (sectorValue) => {
  return DEPARTMENTS.filter(dept => dept.sector === sectorValue);
};

// Helper function to get sector label
export const getSectorLabel = (sectorValue) => {
  const sector = SECTORS.find(s => s.value === sectorValue);
  return sector ? sector.label : sectorValue;
};

// Helper function to get department label
export const getDepartmentLabel = (departmentValue) => {
  const department = DEPARTMENTS.find(d => d.value === departmentValue);
  return department ? department.label : departmentValue;
};